import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';
import { getSupplyDrilldown } from '../../common/endpoints';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchSupplyDrilldown = createApi(
  getSupplyDrilldown,
  'GET'
);

const supplyDrilldownSlice = createSlice({
  name: 'supplyDrilldown',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSupplyDrilldown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSupplyDrilldown.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSupplyDrilldown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default supplyDrilldownSlice.reducer;
